export default __webpack_public_path__ + "static/trends-9d5056716fab5ba43ffd235b4f7b39b4.png";